// extracted by mini-css-extract-plugin
module.exports = {"wrap":"table_wrap___4cbA","admin_table":"table_admin_table__1TV81"};